module.exports = __webpack_public_path__ + "img/damnntips.772cf554.png";